const storage = window.localStorage

export default {
  save (key, value) {
    storage.setItem(key, value)
  },
  read (key) {
    let val = storage.getItem(key)
    try {
      return (new Function('return ' + val))()
    } catch (e) {
      return val
    }
  },
  clear (key) {
    if (key) {
      storage.removeItem(key)
    } else {
      storage.clear()
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/localStorage.js